<template>
  <div class="workshop-material-list" ref="pdfContent" id="workshop-material-list">
    <!-- 加载状态 -->
    <div v-if="loading" class="loading-overlay">
      <div class="loading-text">正在加载料单数据...</div>
    </div>
    
    <!-- 按页分组显示 -->
    <div 
      v-for="(page, pageIndex) in allPages" 
      :key="'page-' + pageIndex"
      class="pdf-page"
    >
      
      <!-- 显示头部 v-if="page.isFirstPage" -->
      <div class="header-section">
        <div class="page" style="position: absolute;top: 0px;left: 0px;">{{ pageIndex + 1 }}</div>
        <div class="header-left">
          <div class="logo-container">
            <img :src="jfLogo" alt="" style="width: 100%;height: 100%;">
          </div>
          <div>
            <div style="display: flex;align-items: center;justify-content: flex-start;">
              <div class="company-name">上海江丰家具集团有限公司</div>
                <!-- 标题区域 -->
                <div class="title-section">
                    <div class="title-box">车间加工料单</div>
                </div>
            </div>
            <div class="product-spec">客户品号：{{ formData.productNo || '/' }}</div>
          </div>
        </div>
        <div class="header-right">
          <div class="print-date">打印日期 {{ printDate }}</div>
          <div class="qr-code-placeholder">
            <img :src="getQRCodeUrl(formData.productOrderItemId)" alt="二维码" style="width: 100%;height: 100%;">
          </div>
        </div>
      </div>
      <!-- 主表格区域 - 只在有材料行时显示 -->
      <div class="main-table-section">
        <!-- 第一页显示表头信息 v-if="page.isFirstPage" -->
        <!-- <template> -->
          <div class="table-header-row-1">
            <div class="header-cell header-cell-one">
              <div class="label">销售单号</div>
              <div class="value">{{ formData.salesOrderNo || '' }}</div>
            </div>
            <div class="header-cell header-cell-two">
              <div class="label">订单批号</div>
              <div class="value">{{ formData.batch || '' }}</div>
              <!-- <div class="value">{{ formData.orderBatchNo || '' }}</div> -->
            </div>
            <div class="header-cell header-cell-three">
              <div class="label">项目名称</div>
              <div class="value">{{ formData.projectName || '' }}</div>
            </div>
            <div class="header-cell header-cell-four">
              <div class="label">下单日期</div>
              <div class="value">{{ formData.orderDate || '' }}</div>
            </div>
            <div class="header-cell header-cell-five">
              <div class="label" style="padding: 0 8px;">制表</div>
              <div class="value">{{ formData.userNickname || '' }}</div>
            </div>
          </div>
          <div class="table-header-row-1">
            <div class="header-cell header-cell-one">
              <div class="label">产品编号</div>
              <div class="value">{{ formData.orderBatchNo || '' }}</div>
            </div>
            <div class="header-cell header-cell-two">
              <div class="label">产品名称</div>
              <div class="value">{{ formData.productName || '' }}</div>
            </div>
            <div class="header-cell header-cell-three">
              <div class="label">产品规格</div>
              <div class="value">{{ formData.width }}{{ formData.depth }}{{ formData.height }}</div>
            </div>
            <div class="header-cell header-cell-four">
              <div class="label">产品数量</div>
              <div class="value">{{ formData.productQuantity || '' }}</div>
            </div>
            <div class="header-cell header-cell-five">
              <div class="label" style="padding: 0 8px;">审核</div>
              <div class="value" style="padding: 0 16px;"></div>
            </div>
          </div>
        <!-- </template> -->
        <!-- 第二行表头（详细列）- 每页都显示 -->
        <div v-if="page.materialRows.length > 0"  class="table-header-row-2">
          <div class="header-col">序号</div>
          <div class="header-col">包装</div>
          <div class="header-col">成品</div>
          <div class="header-col">组件</div>
          <div class="header-col">零件</div>
          <div class="header-col">用料材质</div>
          <div class="header-col">W</div>
          <div class="header-col">D</div>
          <div class="header-col">H</div>
          <div class="header-col">弯</div>
          <div class="header-col">单件数</div>
          <div class="header-col">总</div>
          <div class="header-col">备</div>
          <div class="header-col">白</div>
          <div class="header-col">油</div>
          <div class="header-col">沙</div>
          <div class="header-col">成</div>
          <div class="header-col">正饰面</div>
          <div class="header-col">背饰面</div>
          <div class="header-col">封边材质</div>
          <div class="header-col">W</div>
          <div class="header-col">D</div>
          <div class="header-col">备注</div>
        </div>

        <!-- 数据行 -->
        <div class="table-data-rows" v-if="page.materialRows.length > 0">
          <div 
            v-for="(row, index) in page.materialRows" 
            :key="'material-' + pageIndex + '-' + index" 
            class="data-row"
          >
            <div class="data-col">{{ row.sequenceNo || '' }}</div>
            <div class="data-col">{{ row.packaging || '' }}</div>
            <div class="data-col">{{ row.finishedProduct || '' }}</div>
            <div class="data-col">{{ row.component || '' }}</div>
            <div class="data-col">{{ row.part || '' }}</div>
            <div class="data-col" style="line-height: 1.2;">{{ row.material || '' }}<br>{{ row.materialSpec || '' }}</div>
            <div class="data-col">{{ row.width || '' }}</div>
            <div class="data-col">{{ row.depth || '' }}</div>
            <div class="data-col">{{ row.height || '' }}</div>
            <div class="data-col">{{ row.bend || '' }}</div>
            <div class="data-col">{{ row.quantityPerPiece || '' }}</div>
            <div class="data-col">{{ row.total || '' }}</div>
            <div class="data-col"></div>
            <div class="data-col"></div>
            <div class="data-col"></div>
            <div class="data-col"></div>
            <div class="data-col"></div>
            <div class="data-col">{{ row.frontFinish || '' }}<br>{{ row.frontFinishMaterial || '' }}</div>
            <div class="data-col">{{ row.backFinish || '' }}<br>{{ row.backFinishMaterial || '' }}</div>
            <div class="data-col">{{ row.edgeBandingMaterial || '' }}</div>
            <div class="data-col">{{ row.edgeBandingW || '' }}</div>
            <div class="data-col">{{ row.edgeBandingD || '' }}</div>
            <div class="data-col">{{ row.remarks || '' }}</div>
          </div>
        </div>
      </div>

      <!-- 五金明细区域 -->
      <div v-if="page.hardwareRows.length > 0" class="hardware-section">
        <div class="hardware-title">五金明细</div>
        <div class="hardware-table">
          <!-- 表头 -->
          <div class="hardware-header-row">
            <div class="hardware-header-col">序号</div>
            <div class="hardware-header-col"></div>
            <div class="hardware-header-col">组件</div>
            <div class="hardware-header-col">零件</div>
            <div class="hardware-header-col">用料材质</div>
            <div class="hardware-header-col">W</div>
            <div class="hardware-header-col">D</div>
            <div class="hardware-header-col">H</div>
            <div class="hardware-header-col"></div>
            <div class="hardware-header-col">单件数</div>
            <div class="hardware-header-col">单位</div>
            <div class="hardware-header-col">备注</div>
          </div>
          <!-- 数据行 -->
          <div class="hardware-data-rows">
            <div 
              v-for="(row, index) in page.hardwareRows" 
              :key="'hardware-' + pageIndex + '-' + index" 
              class="hardware-data-row"
            >
              <div class="hardware-data-col">{{ row.sequenceNo || '' }}</div>
              <div class="hardware-data-col"></div>
              <div class="hardware-data-col">{{ row.component || '' }}</div>
              <div class="hardware-data-col">{{ row.part || '' }}</div>
              <div class="hardware-data-col">{{ row.material || '' }}<br>{{ row.materialSpec || '' }}</div>
              <div class="hardware-data-col">{{ row.width || '' }}</div>
              <div class="hardware-data-col">{{ row.depth || '' }}</div>
              <div class="hardware-data-col">{{ row.height || '' }}</div>
              <div class="hardware-data-col"></div>
              <div class="hardware-data-col">{{ row.quantityPerPiece || '' }}</div>
              <div class="hardware-data-col">{{ row.unit || '' }}</div>
              <div class="hardware-data-col">{{ row.remarks || '' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from 'vue'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { contractApi } from '@/services/api'
import jfLogo from '@/assets/jf.png'

interface MaterialRow {
  sequenceNo?: string
  packaging?: string
  finishedProduct?: string
  component?: string
  part?: string
  material?: string
  materialSpec?: string
  width?: string
  depth?: string
  height?: string
  bend?: string
  quantityPerPiece?: string
  total?: string
  spare?: string
  white?: string
  oil?: string
  sand?: string
  completed?: string
  frontFinish?: string
  frontFinishMaterial?: string
  backFinish?: string
  backFinishMaterial?: string
  edgeBandingMaterial?: string
  edgeBandingW?: string
  edgeBandingD?: string
  remarks?: string
}

interface HardwareRow {
  sequenceNo?: string
  component?: string
  part?: string
  material?: string
  materialSpec?: string
  width?: string
  depth?: string
  height?: string
  quantityPerPiece?: string
  unit?: string
  remarks?: string
}

interface FormData {
  productOrderItemId?: string
  batch?: string
  salesOrderNo?: string
  orderBatchNo?: string
  projectName?: string
  orderDate?: string
  preparedBy?: string
  productNo?: string
  productName?: string
  productSpec?: string
  width?: string
  depth?: string
  height?: string
  productQuantity?: string
  approvedBy?: string
  userNickname?: string
  materialRows: MaterialRow[]
  hardwareRows: HardwareRow[]
}

const props = defineProps<{
  productId?: number | string
  productInfo?: {
    code?: string
    contractCode?: string
    project?: string
    nameShort?: string
    count?: number
    deliveryTime?: string
    toProductionTime?: string
    syscode?: string
    width?: string
    depth?: string
    height?: string
  }
}>()

const pdfContent = ref<HTMLElement | null>(null)
const loading = ref(false)

// 格式化当前日期时间
const printDate = computed(() => {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  const seconds = String(now.getSeconds()).padStart(2, '0')
  return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`
})

// 表单数据
const formData = ref<FormData>({
  productOrderItemId: '',
  batch: '',
  salesOrderNo: '',
  orderBatchNo: '',
  projectName: '',
  orderDate: '',
  preparedBy: '',
  productNo: '',
  productName: '',
  productSpec: '',
  width: '',
  depth: '',
  height: '',
  productQuantity: '',
  approvedBy: '',
  userNickname: '',
  materialRows: [],
  hardwareRows: []
})

// 格式化日期
const formatDateStr = (date: string) => {
  if (!date) return ''
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}/${month}/${day}`
}

// 加载物料清单数据
const loadMaterialBomData = async () => {
  if (!props.productId) {
    return
  }

  try {
    loading.value = true
    
    // 分别调用接口获取材料行和五金明细
    const [materialRes, hardwareRes] = await Promise.all([
      contractApi.loadMaterialBomItems({
        productOrderItemId: props.productId,
        jinshu: 0, // 材料行
      }),
      contractApi.loadMaterialBomItems({
        productOrderItemId: props.productId,
        jinshu: 1, // 五金明细
      }),
    ])

    const materialData = materialRes?.code === 0 ? materialRes.data : null
    const hardwareData = hardwareRes?.code === 0 ? hardwareRes.data : null

    if (materialData || hardwareData) {
      const materialItems = materialData?.items || []
      const hardwareItems = hardwareData?.items || []
      const bom = materialData?.bom || hardwareData?.bom || {}

      // 设置产品基本信息
      if (props.productInfo) {
        console.log(props.productInfo)
        formData.value.productOrderItemId = props.productId || ''
        formData.value.batch = props.productInfo.batch || ''
        formData.value.salesOrderNo = props.productInfo.contractCode || ''
        formData.value.orderBatchNo = props.productInfo.code || ''
        formData.value.projectName = props.productInfo.project || ''
        formData.value.orderDate = formatDateStr(props.productInfo.toProductionTime || props.productInfo.deliveryTime || '')
        formData.value.productNo = props.productInfo.syscode || ''
        formData.value.productName = props.productInfo.nameShort || ''
        formData.value.productQuantity = props.productInfo.count ? String(props.productInfo.count) : ''
        formData.value.width = props.productInfo.width ? String(props.productInfo.width) + 'mm' + ' * ' : ''
        formData.value.depth = props.productInfo.depth ? String(props.productInfo.depth) + 'mm' + ' * ' : ''
        formData.value.height = props.productInfo.height ? String(props.productInfo.height) + 'mm' : ''
        formData.value.userNickname = props.productInfo.userNickname || ''
        // formData.value.productSpec = (props.productInfo.width ? props.productInfo.width + 'mm' + ' * ' : '') + (props.productInfo.depth ? props.productInfo.depth + 'mm' + ' * ' : '') + (props.productInfo.height ? props.productInfo.height + 'mm' : '')
      }
      // 转换材料行数据
      const materialRows = materialItems.map((item: any) => ({
        jinshu: 0,
        sequenceNo: item.sequenceNo,
        packaging: item.packageNo || '',
        finishedProduct: item.finishedComponentName || '',
        component: item.componentName || '',
        part: item.partName || '',
        material: item.materialName || '',
        materialSpec: item.materialSpec || '',
        width: item.width ? String(item.width) : '',
        depth: item.depth ? String(item.depth) : '',
        height: item.height ? String(item.height) : '',
        bend: item.bend ? String(item.bend) : '',
        quantityPerPiece: item.quantity ? String(item.quantity) : '',
        total: item.quantity * props.productInfo.count ? String(item.quantity * props.productInfo.count) : '',
        spare: '',
        white: '',
        oil: item.paintMethod || '',
        sand: '',
        completed: '',
        frontFinish: item.frontFinish || '',
        frontFinishMaterial: item.frontFinishMaterial || '',
        backFinish: item.backFinish || '',
        backFinishMaterial: item.backFinishMaterial || '',
        edgeBandingMaterial: item.edgeMaterial || '',
        edgeBandingW: item.edgeWidth ? String(item.edgeWidth) : '',
        edgeBandingD: item.edgeDepth ? String(item.edgeDepth) : '',
        remarks: item.remark || ''
      }))

      formData.value.materialRows = materialRows

      // 转换五金明细数据
      const hardwareRows = hardwareItems.map((item: any) => ({
        jinshu: 1,
        sequenceNo: item.sequenceNo,
        component: item.componentName || '',
        part: item.partName || '',
        material: item.materialName || '',
        materialSpec: item.materialSpec || '',
        width: item.width ? String(item.width) : '',
        depth: item.depth ? String(item.depth) : '',
        height: item.height ? String(item.height) : '',
        quantityPerPiece: item.quantity ? String(item.quantity) : '',
        unit: item.unit || '',
        remarks: item.remark || ''
      }))

      formData.value.hardwareRows = hardwareRows
      console.log('formData.value.hardwareRows五金明细', formData.value.hardwareRows)
    }
  } catch (error) {
    console.error('加载物料清单数据失败:', error)
  } finally {
    loading.value = false
  }
}

// 确保数据行数
const ensureDataRows = () => {
  // 确保至少有10行材料数据
  while (formData.value.materialRows.length < 10) {
    formData.value.materialRows.push({})
  }
  // 确保至少有6行五金数据
  while (formData.value.hardwareRows.length < 6) {
    formData.value.hardwareRows.push({})
  }
}

// 获取二维码URL
const getQRCodeUrl = (productOrderItemId: number) => {
  if(import.meta.env.VITE_API_BASE_URL){
    return `${import.meta.env.VITE_API_BASE_URL}/jf/contract/product/qrcode?id=${productOrderItemId}`;
  }
}

// 页面高度设置（px）
const PAGE_TOTAL_HEIGHT = 794 // 每页总高度
const PAGE_CONTENT_HEIGHT = 442 // 表格内容高度（每页控制在400px左右）

// 固定高度（px）
const HEADER_HEIGHT = 100 // 头部区域高度
const TABLE_HEADER_HEIGHT = 70 // 表头区域高度（table-header-row-1 * 2 + table-header-row-2）
const ROW_HEIGHT = 40 // 每行数据估算高度
const HARDWARE_TITLE_HEIGHT = 40 // 五金明细标题高度
const HARDWARE_HEADER_HEIGHT = 30 // 五金明细表头高度

// 获取行的实际高度（通过DOM测量，如果DOM未渲染则使用估算值）
const getRowHeight = (rowElement: HTMLElement | null): number => {
  if (rowElement) {
    return rowElement.offsetHeight || ROW_HEIGHT
  }
  return ROW_HEIGHT
}

// 将材料行按页分组
const paginatedMaterialRows = computed(() => {
  const { firstPageRows, otherPageRows } = calculateRowsPerPage()
  const pages: MaterialRow[][] = []
  
  if (formData.value.materialRows.length === 0) return pages
  
  // 第一页
  const firstPage = formData.value.materialRows.slice(0, firstPageRows)
  pages.push(firstPage)
  
  // 后续页
  let startIndex = firstPageRows
  while (startIndex < formData.value.materialRows.length) {
    const page = formData.value.materialRows.slice(startIndex, startIndex + otherPageRows)
    pages.push(page)
    startIndex += otherPageRows
  }
  
  return pages
})

// 计算所有页面数据（材料行 + 五金明细）
interface PageData {
  materialRows: MaterialRow[]
  hardwareRows: HardwareRow[]
  isFirstPage: boolean
}

const allPages = computed(() => {
  const pages: PageData[] = []
  const materialRows = formData.value.materialRows
  const hardwareRows = formData.value.hardwareRows
  
  // 第一页：总高度600px，减去头部(100px)和表头(70px)，表格内容可用约430px，控制在400px
  const firstPageContentHeight = PAGE_CONTENT_HEIGHT
  
  // 后续页：总高度600px，减去表头(70px)，表格内容可用约530px，控制在400px
  const otherPageContentHeight = PAGE_CONTENT_HEIGHT
  
  let materialStartIndex = 0
  let isFirstPage = true
  
  // 处理材料行分页（按高度累加）
  while (materialStartIndex < materialRows.length) {
    const currentPageContentHeight = isFirstPage ? firstPageContentHeight : otherPageContentHeight
    let currentHeight = 0
    const pageMaterialRows: MaterialRow[] = []
    
    // 累加行高度直到达到限制
    while (materialStartIndex < materialRows.length && currentHeight < currentPageContentHeight) {
      const row = materialRows[materialStartIndex]
      const rowHeight = ROW_HEIGHT // 使用估算高度，实际渲染时会更准确
      
      // 如果加上这一行会超出限制，且当前页已有内容，则停止
      if (currentHeight + rowHeight > currentPageContentHeight && pageMaterialRows.length > 0) {
        break
      }
      
      pageMaterialRows.push(row)
      currentHeight += rowHeight
      materialStartIndex++
    }
    
    if (pageMaterialRows.length > 0) {
      pages.push({
        materialRows: pageMaterialRows,
        hardwareRows: [],
        isFirstPage: isFirstPage
      })
      isFirstPage = false
    }
  }
  
  // 处理五金明细分页
  if (hardwareRows.length > 0) {
    let hardwareStartIndex = 0
    // 如果材料行为空，第一页五金明细应该显示头部
    let isFirstHardwarePage = pages.length === 0
    
    // 如果最后一页还有空间，先填充五金明细
    if (pages.length > 0) {
      const lastPage = pages[pages.length - 1]
      const lastPageContentHeight = lastPage.isFirstPage ? firstPageContentHeight : otherPageContentHeight
      
      // 计算已使用的材料行高度
      const usedMaterialHeight = lastPage.materialRows.length * ROW_HEIGHT
      const remainingHeight = lastPageContentHeight - usedMaterialHeight
      
      // 如果剩余空间足够放置五金明细标题和至少一行，则填充
      if (remainingHeight > HARDWARE_TITLE_HEIGHT + HARDWARE_HEADER_HEIGHT + ROW_HEIGHT) {
        const availableHeight = remainingHeight - HARDWARE_TITLE_HEIGHT - HARDWARE_HEADER_HEIGHT
        let hardwareHeight = 0
        const pageHardwareRows: HardwareRow[] = []
        
        while (hardwareStartIndex < hardwareRows.length && hardwareHeight < availableHeight) {
          const row = hardwareRows[hardwareStartIndex]
          const rowHeight = ROW_HEIGHT
          
          if (hardwareHeight + rowHeight > availableHeight && pageHardwareRows.length > 0) {
            break
          }
          
          pageHardwareRows.push(row)
          hardwareHeight += rowHeight
          hardwareStartIndex++
        }
        
        if (pageHardwareRows.length > 0) {
          lastPage.hardwareRows = pageHardwareRows
        }
      }
    }
    
    // 剩余的五金行创建新页
    while (hardwareStartIndex < hardwareRows.length) {
      let currentHeight = 0
      const pageHardwareRows: HardwareRow[] = []
      
      // 五金明细页需要包含标题和表头
      // 如果是第一页且材料行为空，需要考虑头部高度
      const hardwarePageContentHeight = isFirstHardwarePage 
        ? firstPageContentHeight - HARDWARE_TITLE_HEIGHT - HARDWARE_HEADER_HEIGHT
        : otherPageContentHeight - HARDWARE_TITLE_HEIGHT - HARDWARE_HEADER_HEIGHT
      
      while (hardwareStartIndex < hardwareRows.length && currentHeight < hardwarePageContentHeight) {
        const row = hardwareRows[hardwareStartIndex]
        const rowHeight = ROW_HEIGHT
        
        if (currentHeight + rowHeight > hardwarePageContentHeight && pageHardwareRows.length > 0) {
          break
        }
        
        pageHardwareRows.push(row)
        currentHeight += rowHeight
        hardwareStartIndex++
      }
      
      // 只有在有内容时才创建页面
      if (pageHardwareRows.length > 0) {
        pages.push({
          materialRows: [],
          hardwareRows: pageHardwareRows,
          isFirstPage: isFirstHardwarePage
        })
        isFirstHardwarePage = false // 后续页不再是第一页
      }
    }
  }
  
  // 过滤掉空页面（既没有材料行也没有五金明细的页面）
  return pages.filter(page => page.materialRows.length > 0 || page.hardwareRows.length > 0)
})

// 初始化数据
onMounted(() => {
  if (props.productId) {
    loadMaterialBomData().then(() => {
      // ensureDataRows()
    })
  } else {
    // ensureDataRows()
  }
})

// 监听 productId 变化
watch(() => props.productId, (newId) => {
  if (newId) {
    loadMaterialBomData().then(() => {
      // ensureDataRows()
    })
  }
})

// 导出PDF
const exportToPDF = async () => {
  if (!pdfContent.value) {
    console.error('PDF内容元素不存在')
    return
  }

  try {
    // 获取所有页面元素（每个 pdf-page 就是一张 A4 纸）
    const pages = pdfContent.value.querySelectorAll('.pdf-page')
    
    if (pages.length === 0) {
      console.error('未找到 pdf-page 元素')
      return
    }
    
    // 创建PDF（A4横向）
    const pdf = new jsPDF('landscape', 'mm', 'a4')
    const pageWidth = pdf.internal.pageSize.getWidth() // 297mm
    const pageHeight = pdf.internal.pageSize.getHeight() // 210mm

    // 处理每一页
    for (let i = 0; i < pages.length; i++) {
      if (i > 0) {
        pdf.addPage()
      }

      const pageElement = pages[i] as HTMLElement
      
      // 使用 html2canvas 将 pdf-page 转换为图片
      const canvas = await html2canvas(pageElement, {
        scale: 2, // 提高清晰度
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
        width: pageElement.scrollWidth,
        height: pageElement.scrollHeight
      })

      // 将 canvas 转换为图片数据
      const imgData = canvas.toDataURL('image/png')
      
      // 每个 pdf-page 已经是 A4 尺寸（297mm x 210mm = 1123px x 794px at 96dpi）
      // html2canvas 使用 scale=2，所以 canvas 尺寸是 2246px x 1588px
      // 直接按 A4 尺寸添加到 PDF，从 (0, 0) 开始，填满整页
      pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, pageHeight)
    }

    // 保存PDF
    const fileName = `车间加工料单_${formData.value.orderBatchNo || '未命名'}_${new Date().getTime()}.pdf`
    pdf.save(fileName)
  } catch (error) {
    console.error('导出PDF失败:', error)
    throw error
  }
}

// 暴露方法供父组件调用
defineExpose({
  exportToPDF
})
</script>

<style lang="scss" scoped>
.workshop-material-list {
  width: 100%;
  background: #ffffff;
  // padding: 20px;
  box-sizing: border-box;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  color: #000;
  position: relative;

  // 每页容器
  .pdf-page {
    // A4横向尺寸：297mm x 210mm
    // 在96dpi下，1mm ≈ 3.779527559px
    // width: 1123px; // 297mm
    width: 100%;
    height: 848px; // 210mm
    page-break-after: always;
    page-break-inside: avoid;
    break-after: page;
    break-inside: avoid;
    // margin-bottom: 100px;
    padding: 20px;
    box-sizing: border-box;
    overflow: hidden; // 隐藏超出部分，确保每页正好是A4尺寸
    
    // &:last-child {
    //   page-break-after: auto;
    //   break-after: auto;
    //   margin-bottom: 0;
    // }
  }

  .header-section {
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
    position: relative;
    .header-left {
      display: flex;
      align-items: center;
      gap: 12px;

      .logo-container {
        width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
      }

      .company-name {
        font-size: 20px;
        font-weight: 400;
        color: #000;
        margin-right: 10px;
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 16px;

      .print-date {
        font-size: 12px;
        color: #666;
      }

      .qr-code-placeholder {
        width: 70px;
        height: 70px;
        background: #f0f0f0;
        border: 1px solid #ddd;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #999;
      }
    }
  }

  .title-section {
    margin-top: 4px;

    .title-box {
      display: inline-block;
      padding: 0px 4px;
      border: 1px solid #000;
      border-radius: 4px;
      font-size: 15px;
      color: #D2475D;
    }
  }

  .main-table-section {
    border: 1px solid #000;
    // margin-bottom: 120px;

    .table-header-row-1 {
      display: grid;
      border-bottom: 1px solid #000;
      // 产品编号的label下面是序号和包装，value下面是成品、组件和零件 = 5列
      // 产品名称的label下面是用料材质，value下面是W、D和H = 4列
      // 产品规格的label下面是弯、单件数和总，value下面是备、白、油、沙、成、正饰面和背饰面 = 10列
      // 产品数量的label下面是封边材质，value下面是W和D = 3列
      // 审核的label和value下面是备注 = 1列
      grid-template-columns: 
        1.83fr  // 产品编号: 序号(0.355)+包装(0.355)+成品(0.376)+组件(0.376)+零件(0.376) = 5列
        1.69fr    // 产品名称: 用料材质(0.725)+W(0.325)+D(0.325)+H(0.325) = 4列
        4.512fr      // 产品规格: 弯(0.5)+单件数(0.5)+总(0.5)+备(0.5)+白(0.5)+油(0.5)+沙(0.5)+成(0.5)+正饰面(0.5)+背饰面(0.5) = 10列
        1.5fr    // 产品数量: 封边材质(0.5)+W(0.5)+D(0.5) = 3列
        1fr;   // 审核: 备注(0.5) = 1列

      .header-cell-one{
        display: grid!important;
        grid-template-columns: 0.73fr 1.14fr;
      }
      .header-cell-two {
        display: grid!important;
        grid-template-columns: 0.745fr 1.006fr;
      }
      .header-cell-three {
        display: grid!important;
        grid-template-columns: 0.615fr 1.7fr;
      }
      .header-cell-four {
        display: grid!important;
        grid-template-columns: 1.56fr 1.2fr;
      }
      .header-cell-five {
        display: grid!important;
        grid-template-columns: 0.62fr 1.7fr;
      }
      .header-cell {
          border-right: 1px solid #000;
        //   padding: 8px;
          height: 34px;
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 8px;
          word-wrap: break-word;
          word-break: break-all;
          white-space: normal;
          overflow-wrap: break-word;
          box-sizing: border-box;
          &:last-child {
            border-right: none;
          }

          .label {
            font-size: 12px;
            font-weight: bold;
            color: #000;
            white-space: nowrap;
            flex-shrink: 0;
            background-color: #EEEEEE;
            border-right: 1px solid #000;
            height: 100%;
            // padding: 0 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
          }

          .value {
            font-size: 12px;
            color: #000;
            min-height: 16px;
            word-wrap: break-word;
            word-break: break-all;
            white-space: normal;
            overflow-wrap: break-word;
            line-height: 1.4;
            flex: 1;
          }
        }
    }

    .table-header-row-2 {
      display: grid;
      grid-template-columns: 0.343fr 0.343fr 0.382fr 0.382fr 0.382fr 0.688fr 0.335fr 0.335fr 0.335fr 0.28fr 0.4fr 0.5fr 0.3fr 0.3fr 0.3fr 0.3fr 0.3fr 0.92fr 0.92fr 0.8fr 0.35fr 0.35fr 1fr;
      // grid-template-columns: repeat(23, 1fr);
      border-bottom: 1px solid #000;
      background: #EEEEEE;

      .header-col {
        border-right: 1px solid #000;
        padding: 6px 4px;
        text-align: center;
        font-size: 11px;
        font-weight: bold;
        color: #000;

        &:last-child {
          border-right: none;
        }
      }
    }

    .table-data-rows {
      .data-row {
        display: grid;
        grid-template-columns: 0.343fr 0.343fr 0.382fr 0.382fr 0.382fr 0.688fr 0.335fr 0.335fr 0.335fr 0.28fr 0.4fr 0.5fr 0.3fr 0.3fr 0.3fr 0.3fr 0.3fr 0.92fr 0.92fr 0.8fr 0.35fr 0.35fr 1fr;
        border-bottom: 1px solid #000;
        min-height: 32px;
        align-items: stretch;

        &:last-child {
          border-bottom: none;
        }

        .data-col {
          border-right: 1px solid #000;
          // padding: 6px 4px;
          text-align: center;
          font-size: 11px;
          color: #000;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          word-wrap: break-word;
          word-break: break-all;
          white-space: normal;
          overflow-wrap: break-word;
          line-height: 1.4;
          overflow: hidden;
          min-width: 0;

          &:last-child {
            border-right: none;
          }
        }
      }
    }
  }

  .hardware-section {
    margin-top: 20px;
    // margin-bottom: 120px;
    .hardware-title {
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 12px;
      color: #000;
    }

    .hardware-table {
      border: 1px solid #000;

      .hardware-header-row {
        display: grid;
        grid-template-columns: 0.343fr 0.343fr 0.382fr 0.764fr 0.688fr 0.335fr 0.335fr 0.335fr 0.28fr 0.4fr 0.5fr 5.84fr;

        // grid-template-columns: repeat(10, 1fr);
        border-bottom: 1px solid #000;
        background: #EEEEEE;

        .hardware-header-col {
          border-right: 1px solid #000;
          padding: 6px 4px;
          text-align: center;
          font-size: 11px;
          font-weight: bold;
          color: #000;

          &:last-child {
            border-right: none;
          }
        }
      }

      .hardware-data-rows {
        // height: 40px;
        .hardware-data-row {
          display: grid;
          grid-template-columns: 0.343fr 0.343fr 0.382fr 0.764fr 0.688fr 0.335fr 0.335fr 0.335fr 0.28fr 0.4fr 0.5fr 5.84fr;
          // grid-template-columns: repeat(10, 1fr);
          border-bottom: 1px solid #000;
          min-height: 32px;
          align-items: stretch;

          &:last-child {
            border-bottom: none;
          }

          .hardware-data-col {
            border-right: 1px solid #000;
            // padding: 6px 4px;
            text-align: center;
            font-size: 11px;
            color: #000;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            word-wrap: break-word;
            word-break: break-all;
            white-space: normal;
            overflow-wrap: break-word;
            line-height: 1.4;
            overflow: hidden;
            min-width: 0;

            &:last-child {
              border-right: none;
            }
          }
        }
      }
    }
  }

  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    .loading-text {
      font-size: 16px;
      color: #666;
    }
  }
}
</style>

